<style scoped>
  @import "payment-method.scss";
</style>

<template>
  <div>
    <div
      v-if="noCardFound"
      class="alert alert-danger mb-0 mt-2"
    >
      {{ $t ('errorMessages.NO_CARD_FOUND') }}
      <img
        id="add-card-img"
        src="@/assets/images/add_icon.png"
        class="add-img float-right d-inline"
        @click="addCardPage()"
      >
    </div>
    <div
      v-if="!showAddCard"
      class="row"
    >
      <div
        v-if="!noCardFound"
        class="p-2 mt-4 payment-method-label col-md-12"
      >
        <h4 class="font-weight-bold ml-2">
          {{ $t ('header.paymentMethod') }}
          <img
            id="add-card-img"
            src="@/assets/images/add_icon.png"
            class="add-img float-right d-inline mt-1"
            @click="addCardPage()"
          >
        </h4>
      </div>
    </div>
    <div v-if="cardLoader">
      <div class="text-center">
        <div
          class="spinner-border m-5"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <div>
          {{ $t ('label.gettingCards') }}
        </div>
      </div>
    </div>
    <div v-else>
      <div
        :class="showAddCard?'height18':'height22'"
        class="card-display mt-3"
      >
        <div class="main-container">
          <card-item
            v-for="(item, index) in cards"
            :key="index"
            :card-item="item"
            class="mt-0"
          />
        </div>
      </div>
    </div>
    <h5
      v-if="showAddCard && !cardLoader && !noCardFound"
      class="mt-5 ml-md-2"
    >
      <img
        id="add-card"
        src="@/assets/images/add_icon_light.png"
        class="add-img d-inline mr-1"
        @click="addCardPage()"
      >
      <span class="align-middle font-weight-bold">
        {{ $t ('label.addNewCard') }}
      </span>
    </h5>
    <div
      id="iframeContainer"
      ref="iframeContainer"
      :class="[
        checkoutProgress ? 'show' : '',
      ]"
      class="iframe-container slide-in">
      <div class="iframe-foreground">
        <iframe
          id="checkoutIframe"
          ref="iframe"
          class="iframe-checkout"
          name="checkout-iframe" />
      </div>
      <div
        id="iframeBackground"
        ref="iframeBackground"
        class="iframe-background" />
    </div>
  </div>
</template>

<script>
import CardItem from './card-item/card-item.vue'
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'
import { CONSTANT } from '@/utils/constant'
import orchestration from '@/orchestration'
import sharedService from '@/utils/shared-service'

export default {
  name: 'PaymentMethod',

  components: { CardItem },

  data () {
    return {
      emailId: 'test@example.com',
      cards: [],
      error: '',
      CONSTANT: CONSTANT,
      cardLoader: true,
      noCardFound: false,
      invokeFromCart: false,
      showAddCard: ''
    }
  },

  computed: {
    ...mapGetters(['isRecognized',
      'consumerAuthorization', 'sortedCards', 'selectedCheckoutExperience', 'checkoutProgress'])
  },

  created () {
    this.$store.commit('lightBoxloaderOn', false)
    this.prepareSrcProfile()
    this.showAddCard = !window.opener
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.error = event
      this.$store.commit('lightBoxloaderOn', false)
    })
    EventBus.$on('refreshCards', (event) => {
      this.$store.commit('checkoutProgress', false)
      this.prepareSrcProfile()
    })
  },

  methods: {
    /**
     * This method routes to add card
     * */
    addCardPage () {
      sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.ADD_CARD_SCREEN, this.$router)
    },

    /**
     * This method calls the src profile based on jwt
     * @returns {Promise<void>}
     */
    async prepareSrcProfile () {
      let response = await this.getSortedCards()
      this.cardLoader = false
      if (response) {
        this.cards = response
        if (this.cards.length <= 0) {
          this.noCardFound = true
        } else {
          this.noCardFound = false
        }
      } else {
        EventBus.$emit('handleError', 'NO_CARD_FOUND')
      }
    },

    /**
     * This method calls the profile from all sdk if not recognized
     * else get the existing profiles and perform sorting based on cardLastUsedDate
     * @param response
     * @param jwtTokens
     * @returns {Promise.<*>}
     */
    getSortedCards: async function (refreshCards = false) {
      let sortedCards = await orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.GET_SRC_PROFILE })
      this.$store.commit('commitSortedCards', sortedCards)
      return sortedCards
    }
  }
}
</script>
